import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ButtonMenuProps } from '@bl/components';
import { BlFrontendBaseComponent } from './bl-frontend-base.component';

@Component({
  selector: 'bl-frontend-button-menu',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class BlFrontendButtonMenuComponent extends BlFrontendBaseComponent<ButtonMenuProps> {
  @Input() text: ButtonMenuProps['text'] = '';
  @Input() variant: ButtonMenuProps['variant'] = 'primary';
  @Input() disabled: ButtonMenuProps['disabled'] = false;
  @Input() type: ButtonMenuProps['type'] = 'button';
  @Input() fullWidth: ButtonMenuProps['fullWidth'] = false;
  @Input() leadingIcon: ButtonMenuProps['leadingIcon'];
  @Input() trailingIcon: ButtonMenuProps['trailingIcon'];
  @Input() density: ButtonMenuProps['density'] = 'regular';

  @Input() menuItems: ButtonMenuProps['menuItems'] = [];
  @Input() menuTarget?: ButtonMenuProps['menuTarget'];
  @Input() maxMenuWidth?: ButtonMenuProps['maxMenuWidth'];
  @Input() maxMenuHeight?: ButtonMenuProps['maxMenuHeight'];

  @Input() ariaLabel?: ButtonMenuProps['ariaLabel'];

  protected override getComponentName(): string {
    return 'ButtonMenu';
  }

  protected override getProps(): ButtonMenuProps {
    return {
      text: this.text,
      variant: this.variant,
      disabled: this.disabled,
      type: this.type,
      fullWidth: this.fullWidth,
      leadingIcon: this.leadingIcon,
      trailingIcon: this.trailingIcon,
      density: this.density,
      menuItems: this.menuItems,
      menuTarget: this.menuTarget,
      maxMenuWidth: this.maxMenuWidth,
      maxMenuHeight: this.maxMenuHeight,
      ariaLabel: this.ariaLabel,
    };
  }
}
